import { Link } from 'react-router-dom';
import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="scroll-mt-20 py-16 px-6 sm:px-12 lg:px-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
        
        {/* Left Side: Overlapping Images */}
        <div className="relative w-full lg:w-1/2 flex justify-center">
          {/* Main Background Image */}
          <div className="relative z-10 w-4/5 sm:w-3/4 aspect-[4/5] overflow-hidden shadow-2xl rounded-sm">
            <img 
              src="/assets/images/about/img2.jpeg" 
              alt="Electro Titan Store" 
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
            />
          </div>

          {/* Overlapping Secondary Image */}
          <div className="absolute -bottom-8 -right-4 sm:-right-8 z-20 w-3/5 sm:w-1/2 aspect-square overflow-hidden shadow-2xl border-4 border-white rounded-sm hidden sm:block">
            <img 
              src="/assets/images/about/img1.jpeg" 
              alt="Electro Titan Interior" 
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Decorative Background Element */}
          <div className="absolute top-10 -left-10 w-32 h-32 bg-[#ffaa00]/10 -z-0 rounded-full blur-3xl"></div>
        </div>

        {/* Right Side: Content */}
        <div className="w-full lg:w-1/2 text-left">
          <span className="font-raleway text-sm font-bold uppercase tracking-[0.3em] text-[#8A8A89] block mb-4">
            À propos
          </span>
          
          <h2 className="font-raleway text-4xl sm:text-5xl font-black text-black uppercase mb-8 leading-tight tracking-tighter">
            <span className='text-[#8a8a89]'>ELECTRO</span> <span className="text-[#ffaa00]">TITAN</span>
          </h2>
          
          <div className="space-y-6">
            {/* <p className="font-raleway text-[#8A8A89] leading-relaxed text-lg italic">
              "L'excellence technologique au service de votre quotidien."
            </p> */}
            
            <p className="font-raleway text-black text-base sm:text-lg leading-relaxed text-justify">
            Electro Titan est une entreprise de référence dans la vente d’électroménager haut de qualité, alliant innovation, performance et excellence. Nous proposons une sélection rigoureuse d’appareils électroménagers modernes, conçus pour offrir confort, fiabilité et efficacité au quotidien. Grâce à un service client professionnel et des produits au meilleur rapport qualité-prix, Electro Titan accompagne chaque foyer avec des solutions durables, élégantes et adaptées aux exigences modernes.
            </p>

          </div>

          {/* Optional CTA matching your brand */}
          <div className="mt-10">
            <Link to={"/contact"}><button className="px-8 py-3 bg-[#8a8a89] text-white font-raleway font-bold uppercase tracking-widest hover:bg-[#ffaa00] transition-colors duration-300">
                Contactez Nous
            </button></Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;